import DOMHelper from "../../helpers/dom-helper";
import ObjectHelper from "../../helpers/object-helper";

export default class HeroVideo {
    constructor() {
        this.$root = document.getElementById('webinarTranslationRecord');

        if (!this.$root) {
            return;
        }

        this.$poster = this.$root.querySelector('.translation-record-poster');
        this.$videoPlayer = document.getElementById('webinarTranslationRecordVideo');
        this.$play = this.$root.querySelector('.translation-record-play');
        this.$spinner = this.$root.querySelector('.translation-record-spinner');

        this.fLoadYouTubePlayer = this.loadYouTubePlayer.bind(this);
        this.isYouTubePlayerLoaded = false;
        this.isYouTubePlayerReady = false;

        this.init();
    }

    init() {
        this.createPlayer();
    }

    loadYouTubePlayer() {
        if (this.isYouTubePlayerLoaded) {
            return;
        }

        this.isYouTubePlayerLoaded = true;
        DOMHelper.loadYouTubePlayer();
    }

    createPlayer() {
        window.youtubeApiCallbacks.push(() => {
            const origin = location.origin;

            window.youTubePlayer = new YT.Player('webinarTranslationRecordVideo', {
                height: '100%',
                width: '100%',
                videoId: this.$videoPlayer.dataset.videoId,
                playerVars: {
                    'origin': origin
                },
                events: {
                    'onStateChange': e => {
                        if (e.data === 0) {
                            window.youTubePlayer.stopVideo();
                        }
                    },
                    'onReady': () => {
                        this.isYouTubePlayerReady = true;

                        if (this.$poster) {
                            this.playVideo();
                        }
                    }
                }
            });
        });

        this.$poster.addEventListener('click', () => {
            this.loadYouTubePlayer();

            if (this.isYouTubePlayerReady) {
                this.playVideo();
            } else {
                this.$play.remove();
                this.$spinner.classList.remove('-hidden');
            }
        });
    }

    playVideo() {
        this.$videoPlayer = document.getElementById('webinarTranslationRecordVideo');
        this.$videoPlayer.classList.remove('-hidden');
        this.$poster.remove();
        this.$poster = null;

        if (ObjectHelper.get(window, 'youTubePlayer.playVideo')) {
            window.youTubePlayer.playVideo();
        }
    }
}